import { useState } from "react";

export default function Section11() {
  const [isOpen, setIsOpen] = useState(new Array(9).fill(false)); // 9 FAQs now
  const handleFaq = (index) => {
    setIsOpen((prevState) =>
      prevState.map((item, idx) => (idx === index ? !item : false))
    );
  };

  return (
    <div className="w-full Section8 mt-[8%] md:mt-[4%]">
      <div className="w-full section8-container">
        <div className="w-[90%] md:w-[61%] pb-[1%] mx-auto text-center">
          <h2 className="leading-[29px] md:leading-[41px] text-[24px] md:text-[34px] text-[#151515] font-bold my-[0.67em]">
            Frequently Asked Questions
          </h2>
        </div>

        <div className="w-full md:w-[784px] p-5 md:p-[2%] mx-auto faq-container font-open leading-[21px]">
          {/* FAQ 1 */}
          <div className="faq-item text-[11px] md:text-sm rounded-[8px] p-[2%] border border-solid border-[#DEDEDE] mb-[4%]">
            <div
              onClick={() => handleFaq(0)}
              className="question text-[#444444] cursor-pointer flex justify-between items-center"
            >
              What is email marketing?
              <b className="text-[40px] text-[#DA2128] font-[300]">
                {isOpen[0] ? "-" : "+"}
              </b>
            </div>
            <div className={`${isOpen[0] ? "block" : "hidden"} answer text-[#444444]`}>
              <br />
              <p>
                Email marketing is a digital marketing channel that uses targeted emails
                to connect with your audience, build relationships, and drive sales. It
                includes newsletters, promotional offers, automated flows, and
                personalized campaigns designed to increase engagement and revenue.
              </p>
            </div>
          </div>

          {/* FAQ 2 */}
          <div className="faq-item text-[11px] md:text-sm rounded-[8px] p-[2%] border border-solid border-[#DEDEDE] mb-[4%]">
            <div
              onClick={() => handleFaq(1)}
              className="question text-[#444444] cursor-pointer flex justify-between items-center"
            >
              What is included in your email marketing services?
              <b className="text-[40px] text-[#DA2128] font-[300]">
                {isOpen[1] ? "-" : "+"}
              </b>
            </div>
            <div className={`${isOpen[1] ? "block" : "hidden"} answer text-[#444444]`}>
              <br />
              <p>
                Our services cover everything from strategy and list segmentation to
                content creation, automation, A/B testing, and performance tracking. We
                handle the full process so you can focus on growth.
              </p>
            </div>
          </div>

          {/* FAQ 3 */}
          <div className="faq-item text-[11px] md:text-sm rounded-[8px] p-[2%] border border-solid border-[#DEDEDE] mb-[4%]">
            <div
              onClick={() => handleFaq(2)}
              className="question text-[#444444] cursor-pointer flex justify-between items-center"
            >
              How long does it take to see results from email marketing?
              <b className="text-[40px] text-[#DA2128] font-[300]">
                {isOpen[2] ? "-" : "+"}
              </b>
            </div>
            <div className={`${isOpen[2] ? "block" : "hidden"} answer text-[#444444]`}>
              <br />
              <p>
                Most clients start seeing improvements in open rates and engagement
                within the first few weeks. Significant ROI and revenue impact usually
                appear within 2–3 months of consistent campaigns.
              </p>
            </div>
          </div>

          {/* FAQ 4 */}
          <div className="faq-item text-[11px] md:text-sm rounded-[8px] p-[2%] border border-solid border-[#DEDEDE] mb-[4%]">
            <div
              onClick={() => handleFaq(3)}
              className="question text-[#444444] cursor-pointer flex justify-between items-center"
            >
              Do you create the email content and design?
              <b className="text-[40px] text-[#DA2128] font-[300]">
                {isOpen[3] ? "-" : "+"}
              </b>
            </div>
            <div className={`${isOpen[3] ? "block" : "hidden"} answer text-[#444444]`}>
              <br />
              <p>
                Yes. We craft compelling subject lines, persuasive copy, and
                custom-designed templates that align with your brand voice and goals.
              </p>
            </div>
          </div>

          {/* FAQ 5 */}
          <div className="faq-item text-[11px] md:text-sm rounded-[8px] p-[2%] border border-solid border-[#DEDEDE] mb-[4%]">
            <div
              onClick={() => handleFaq(4)}
              className="question text-[#444444] cursor-pointer flex justify-between items-center"
            >
              Which email platforms do you work with?
              <b className="text-[40px] text-[#DA2128] font-[300]">
                {isOpen[4] ? "-" : "+"}
              </b>
            </div>
            <div className={`${isOpen[4] ? "block" : "hidden"} answer text-[#444444]`}>
              <br />
              <p>
                We specialize in platforms like Shopify, Klaviyo, Mailchimp, and
                HubSpot, but our team can adapt to any major email marketing tool you
                already use.
              </p>
            </div>
          </div>

          {/* FAQ 6 */}
          <div className="faq-item text-[11px] md:text-sm rounded-[8px] p-[2%] border border-solid border-[#DEDEDE] mb-[4%]">
            <div
              onClick={() => handleFaq(5)}
              className="question text-[#444444] cursor-pointer flex justify-between items-center"
            >
              Can you set up automated email flows?
              <b className="text-[40px] text-[#DA2128] font-[300]">
                {isOpen[5] ? "-" : "+"}
              </b>
            </div>
            <div className={`${isOpen[5] ? "block" : "hidden"} answer text-[#444444]`}>
              <br />
              <p>
                Absolutely. We create automation workflows such as welcome sequences,
                abandoned cart reminders, re-engagement campaigns, and lifecycle flows
                that boost conversions.
              </p>
            </div>
          </div>

          {/* FAQ 7 */}
          <div className="faq-item text-[11px] md:text-sm rounded-[8px] p-[2%] border border-solid border-[#DEDEDE] mb-[4%]">
            <div
              onClick={() => handleFaq(6)}
              className="question text-[#444444] cursor-pointer flex justify-between items-center"
            >
              How do you measure success in email marketing?
              <b className="text-[40px] text-[#DA2128] font-[300]">
                {isOpen[6] ? "-" : "+"}
              </b>
            </div>
            <div className={`${isOpen[6] ? "block" : "hidden"} answer text-[#444444]`}>
              <br />
              <p>
                We track key metrics like open rates, click-through rates, conversions,
                and ROI. You’ll receive regular reports with clear insights and
                recommendations for ongoing optimization.
              </p>
            </div>
          </div>

          {/* FAQ 8 */}
          <div className="faq-item text-[11px] md:text-sm rounded-[8px] p-[2%] border border-solid border-[#DEDEDE] mb-[4%]">
            <div
              onClick={() => handleFaq(7)}
              className="question text-[#444444] cursor-pointer flex justify-between items-center"
            >
              Is email marketing compliant with GDPR and CAN-SPAM?
              <b className="text-[40px] text-[#DA2128] font-[300]">
                {isOpen[7] ? "-" : "+"}
              </b>
            </div>
            <div className={`${isOpen[7] ? "block" : "hidden"} answer text-[#444444]`}>
              <br />
              <p>
                Yes. We ensure that every campaign follows international compliance
                standards, including GDPR and CAN-SPAM, to protect your brand and
                customers.
              </p>
            </div>
          </div>

          {/* FAQ 9 */}
          <div className="faq-item text-[11px] md:text-sm rounded-[8px] p-[2%] border border-solid border-[#DEDEDE] mb-[4%]">
            <div
              onClick={() => handleFaq(8)}
              className="question text-[#444444] cursor-pointer flex justify-between items-center"
            >
              Do I need a large email list to get started?
              <b className="text-[40px] text-[#DA2128] font-[300]">
                {isOpen[8] ? "-" : "+"}
              </b>
            </div>
            <div className={`${isOpen[8] ? "block" : "hidden"} answer text-[#444444]`}>
              <br />
              <p>
                Not at all. We help businesses grow and nurture their lists over time.
                Even with a small list, targeted campaigns can deliver strong engagement
                and revenue.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="line mb-[55px] md:mb-[4%] mt-[1%] mx-auto w-[70%] md:w-[61%] shadow-line h-2 rounded-[100%]"></div>
    </div>
  );
}
